<template>
  <div>
    <Head />
    <div class="wrap">
      <div class="cont">
        <div class="left">
          <h1>Подготовка к имплантации зубов</h1>
          <p>
            Задача наших врачей – сделать не только красивые протезы, но и восстановить функцию зубов, чтобы Вы могли жевать любые продукты без боли и с наслаждением.
          </p>
          <br>
          <p>
            В зависимости от сложности имплантации зубов существуют следующие этапы подготовки:
          </p>
          <ul>
            <li>консультация врача-стоматолога и осмотр полости рта пациента;</li>
            <li>снимок челюсти для оценки состояния костной ткани. Для этого могут быть назначены: ортопантомограмма, магнитно-резонансная томограмма, КТ;</li>
            <li>сдача анализов;</li>
            <li>составление плана лечения, выбор импланта;</li>
            <li>профессиональная гигиена, которая включает в себя снятие твердых отложений ультразвуком, удаление бактериального налета, шлифовку эмали и обработку форсодержащими препаратами;</li>
            <li>терапевтическая подготовка;</li>
            <li>хирургическая подготовка;</li>
            <li>ортодонтическая подготовка.</li>
          </ul>
          <br>
          <p>
            Более подробную консультацию Вы можете получить, обратившись к нам. 
          </p>
          <br><br>
        </div>
          <a-carousel autoplay arrows effect="fade">
            <template #prevArrow>
              <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                <left-circle-outlined />
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow" style="right: 10px">
                <right-circle-outlined />
              </div>
            </template>
            <div><img class='ii' alt="" src="../assets/pa1.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/pa2.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/pa3.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/pa4.jpg" /></div>
          </a-carousel>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import { Carousel } from 'ant-design-vue';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';
import Foot from '@/components/Foot.vue'

export default {
  name: 'OrthopedicsView',
  components: {
    Head,
    Foot,
    ACarousel: Carousel,
    LeftCircleOutlined, 
    RightCircleOutlined,
  }
}
</script>

<style scoped>

.wrap {
  max-width: 90%;
  margin: 60px auto;
  min-height: 500px;
}

.cont {
  margin: 60px auto;
  margin-bottom: 140px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
}

.left {
  margin-right: 30px;
}

p {
  width: 95%;
}

.ii {
  width: 100%;
  height: 450px;
  overflow: hidden;
  object-fit: cover;
}

.ant-carousel :deep(.slick-slide) {
  text-align: center;
  height: 450px;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 35px;
  height: 25px;
  font-size: 35px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  z-index: 1;
}

.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}

@media (max-width: 790px) {

.cont {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

}

</style>

